import { callAct, isOk, statusText } from "./apiConfig";
import utils from "./utils";

// Areas service — unified onto the PHP backend (acts: areasList/addArea/editArea/delArea).
// PHP areasList returns exactly { ID, name, subToID } (numeric IDs) — same shape the
// components already consume, so no field mapping is needed.

function _isAreaSaved() {
    const isAreaList = utils.isSessionValid('area-list');
    return isAreaList || false;
}

// PHP reports logical failures via debug.statusCode (HTTP stays 200); throw on
// non-OK so the previous Node throw-on-error contract keeps working in components.
function ensureOk(envelope, fallbackMsg) {
    if (!isOk(envelope)) throw new Error(statusText(envelope) || fallbackMsg);
    return envelope;
}

async function getAllArea(isChange = false) {
    const cached = _isAreaSaved();
    if (cached && !isChange) return cached;
    try {
        const envelope = ensureOk(await callAct('areasList', {}), 'Failed to load areas');
        const areas = Array.isArray(envelope?.data) ? envelope.data : [];
        utils.saveSession('area-list', JSON.stringify(areas));
        return areas;
    } catch (error) {
        console.error(error);
        return [];
    }
}

async function editArea(ID, subID, name) {
    return ensureOk(await callAct('editArea', { ID, name, subToID: subID }), 'Failed to update area');
}

async function addArea(name, subId) {
    return ensureOk(await callAct('addArea', { name, subToID: subId }), 'Failed to add area');
}

async function delArea(ID) {
    return ensureOk(await callAct('delArea', { ID }), 'Failed to delete area');
}

const manageareas = { getAllArea, editArea, addArea, delArea };
export default manageareas;
